import { Component, EventEmitter, Input, Output } from '@angular/core'
import { PaymentDestination, PaymentRow, TwinEvidence } from '../../../data/interfaces/lease-ledger.interface'
import { PAYMENT_STATUS_COLOR_ENUM, PAYMENT_STATUS_ENUM } from '@modules/private/payment/data/enum/payment.enum'
import { destinationLetterNumbers } from '../../../data/utils/payment-destination.util'

@Component({
  selector: 'app-payments-view',
  templateUrl: './payments-view.component.html',
  styleUrls: ['./payments-view.component.scss'],
})
export class PaymentsViewComponent {
  /** `payments[]` del ledger más los `unapplied[]` que aún no tienen aplicación (unión por `_id` en el contenedor). */
  @Input() payments: PaymentRow[] = []
  /** Gemelos por `_id` (F18): los arma el contenedor desde `unapplied[]`; aquí solo se pinta el badge. */
  @Input() twinsById = new Map<string, TwinEvidence[]>()
  @Output() openPayment = new EventEmitter<string>()
  //* «Aplicar» por fila con disponible: el contenedor abre el mismo diálogo que la franja (F-02).
  @Output() apply = new EventEmitter<PaymentRow>()

  hasTwins(row: PaymentRow): boolean {
    return (this.twinsById.get(row._id)?.length ?? 0) > 0
  }

  statusLabel(status: string): string {
    return PAYMENT_STATUS_ENUM[status as keyof typeof PAYMENT_STATUS_ENUM] ?? status
  }

  statusSeverity(status: string): string {
    return PAYMENT_STATUS_COLOR_ENUM[status as keyof typeof PAYMENT_STATUS_COLOR_ENUM] ?? 'warning'
  }

  /** Letras que cubrió, con el folio cuando el dinero fue a otro arrendamiento (redistribución). El enganche
   *  y el residual no tienen número de letra: se nombran, no se pintan como «0». Y si el número no se pudo
   *  resolver (`n` nulo) queda solo el folio: nombrar una «letra 0» sería peor que no nombrarla. */
  letters(row: PaymentRow): string {
    const nombre = (a: PaymentDestination) => {
      //* B-039 · Todas las letras a las que se aplicó, no solo la primera.
      const donde = a.applicationType === 'FIRST_PAYMENT' ? 'pago inicial' : a.applicationType === 'RESIDUAL_PAYMENT' ? 'residual' : destinationLetterNumbers(a).join(', ')
      return a.folio ? (donde ? `${a.folio} · ${donde}` : a.folio) : donde
    }
    return row.destinations.filter((a) => a.status !== 'CANCELLED').map(nombre).filter(Boolean).join(', ') || '—'
  }
}
